import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from '../internal/cx';
import styles from './StatusBadge.module.css';

export type StatusTone =
  'neutral' | 'info' | 'success' | 'warning' | 'danger' | 'special' | 'accent';

export interface StatusBadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: StatusTone;
  size?: 'sm' | 'md';
  /** Leading colored dot. Color is supplementary: the text must convey the status. */
  dot?: boolean;
  icon?: ReactNode;
}

export function StatusBadge({
  tone = 'neutral',
  size = 'md',
  dot = false,
  icon,
  className,
  children,
  ...rest
}: StatusBadgeProps) {
  return (
    <span className={cx(styles.badge, styles[tone], styles[size], className)} {...rest}>
      {dot && <span className={styles.dot} aria-hidden="true" />}
      {icon && (
        <span className={styles.icon} aria-hidden="true">
          {icon}
        </span>
      )}
      {children}
    </span>
  );
}
